import React from 'react';
import { getFileIconByMimeType } from 'src/utils/documents';

export interface DocumentCardProps {
  displayName: string;
  downloadUrl: string;
  mimeType?: string | null;
  thumbnailUrl?: string | null;
  kind?: 'image' | 'document';
  onDownload: () => void;
  onPreview?: () => void;
}

const IMAGE_EXT_RE = /\.(png|jpe?g|gif|webp|bmp|svg)$/i;

const DocumentCard: React.FC<DocumentCardProps> = ({
  displayName,
  downloadUrl,
  mimeType,
  thumbnailUrl,
  kind,
  onDownload,
  onPreview,
}) => {
  const isImage =
    !!downloadUrl &&
    (kind === 'image' ||
      (mimeType?.startsWith('image/') ?? false) ||
      IMAGE_EXT_RE.test(displayName));
  const imgSrc = isImage ? downloadUrl : thumbnailUrl || downloadUrl;

  return (
    <div
      className="panel panel-default position-relative"
      style={{ width: '100px', minWidth: '100px' }}
    >
      <div
        onClick={onDownload}
        title="Baixar"
        className={
          'width-20 aspect-ratio-1 rounded-circle bg-white border border-color-light ' +
          'display-grid place-items-center cursor-pointer position-absolute top-0 right-0 ' +
          'translate-x50pct-y-50pct'
        }
      >
        <span className="rioglyph rioglyph-download text-size-12" />
      </div>

      <div className="panel-body padding-5">
        {isImage ? (
          <img
            src={imgSrc}
            alt={displayName}
            onClick={() => onPreview?.()}
            style={{
              width: '100%',
              aspectRatio: '1',
              objectFit: 'cover',
              borderRadius: '4px',
              cursor: onPreview ? 'pointer' : 'default',
            }}
          />
        ) : (
          <div
            title={displayName}
            className="display-flex flex-column align-items-center justify-content-center text-center"
            style={{ width: '100%', aspectRatio: '1' }}
          >
            <span
              className={`${getFileIconByMimeType(mimeType, displayName)} text-size-h3 text-color-gray`}
            />
            <span
              className="text-size-10 text-color-dark margin-top-5 text-bold"
              style={{ wordBreak: 'break-all', lineHeight: '1.2' }}
            >
              {displayName}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentCard;
